import { useRouteMatch } from "react-router";

export const useSystem = () => {
  const match = useRouteMatch<{ system: string }>({
    path: "/app/:system",
    strict: false,
    sensitive: false
  });
  return match?.params.system || "TILES";
};
